import React from 'react';
function UiComponent() {
	return (
		<div>
			{/* Designation Component  */}
			<section className="d-flex justify-content-around p-5">
				<div className="container">
					<h1 className="semibold-18">Designation</h1>
					<div className="row">
						<div className="col-md-12">
							<span className="tag">Logistics Designation</span>
							<span className="tag">Logistics &amp; Ops</span>
							<span className="tag">Logistics &amp; Ops</span>
							<span className="tag">Logistics &amp; Ops</span>
							<span className="tag">Logistics &amp; Ops</span>
						</div>
						<div className="col-md-12 mt-3">
							<span className="tag green">Logistics Designation</span>
							<span className="tag green">Logistics &amp; Ops</span>
							<span className="tag green">Logistics &amp; Ops</span>
							<span className="tag green">Logistics &amp; Ops</span>
							<span className="tag green">Logistics &amp; Ops</span>
						</div>
						<div className="col-md-12 mt-3">
							<span className="tag perple">Logistics Designation</span>
							<span className="tag perple">Logistics &amp; Ops</span>
							<span className="tag perple">Logistics &amp; Ops</span>
							<span className="tag perple">Logistics &amp; Ops</span>
							<span className="tag perple">Logistics &amp; Ops</span>
						</div>
					</div>
				</div>
			</section>
			{/* Avatar Component  */}
			<div className="avatar-component add-buyer py-4">
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<h1 className="semibold-18 pb-2">Avatar Component without add icon</h1>
							<div className="add-buyer">
								<div className="added-members px-0">
									<img
										src=" /images/alave.png"
										alt=""
										data-toggle="tooltip"
										data-placement="top"
										title
										data-original-title="Sadat"
									/>
									<img
										src=" /images/alave.png"
										alt=""
										data-toggle="tooltip"
										data-placement="top"
										title
										data-original-title="Mamun"
									/>
								</div>
							</div>
							<br />
							<div className="add-buyer">
								<div className="added-members px-0">
									<img
										src=" /images/alave.png"
										alt=""
										data-toggle="tooltip"
										data-placement="top"
										title
										data-original-title="Sadat"
									/>
									<img
										src=" /images/alave.png"
										alt=""
										data-toggle="tooltip"
										data-placement="top"
										title
										data-original-title="Mamun"
									/>
									<img
										src=" /images/alave.png"
										alt=""
										data-toggle="tooltip"
										data-placement="top"
										title
										data-original-title="Zahinul Haque"
									/>
									<img
										src=" /images/alave.png"
										alt=""
										data-toggle="tooltip"
										data-placement="top"
										title
										data-original-title="pm"
									/>
									<div className="more-people">
										<a href="#">+1</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="avatar-component add-buyer pb-4">
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<h1 className="semibold-18 pb-2">Avatar Component with add icon</h1>
							<div className="add-buyer">
								<div className="added-members px-0">
									<div id="AddNewMember" className="add-new-member ">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width={39}
											height={39}
											viewBox="0 0 39 39"
										>
											<g
												id="Group_22785"
												data-name="Group 22785"
												transform="translate(-1471 -119)"
											>
												<circle
													id="Ellipse_122"
													data-name="Ellipse 122"
													cx="18.5"
													cy="18.5"
													r="18.5"
													transform="translate(1472 120)"
													fill="#ebe8e8"
													stroke="#fff"
													strokeWidth={2}
												/>
												<text
													id="_"
													data-name="+"
													transform="translate(1484 148)"
													fill="#21242b"
													fontSize={24}
													fontFamily="OpenSans-Semibold, Open Sans"
													fontWeight={600}
												>
													<tspan x={0} y={0}>
														+
													</tspan>
												</text>
											</g>
										</svg>
									</div>
									<img
										src=" /images/alave.png"
										alt=""
										data-toggle="tooltip"
										data-placement="top"
										title
										data-original-title="Sadat"
									/>
									<img
										src=" /images/alave.png"
										alt=""
										data-toggle="tooltip"
										data-placement="top"
										title
										data-original-title="Mamun"
									/>
									<img
										src=" /images/alave.png"
										alt=""
										data-toggle="tooltip"
										data-placement="top"
										title
										data-original-title="Zahinul Haque"
									/>
									<img
										src=" /images/alave.png"
										alt=""
										data-toggle="tooltip"
										data-placement="top"
										title
										data-original-title="pm"
									/>
									<div className="more-people">
										<a href="#">+1</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* Avater Component  */}
			<section className="task-status-section">
				<div className="container">
					<div className="row">
						<div className="col-md-12  d-flex bg-white justify-content-between">
							<div className="one-fourth px-4 py-4">
								<h3 className="semibold-14">No Icon</h3>
								<div className="task-status purple">
									<span className="status-btn">Status</span>
								</div>
								<div className="task-status green">
									<span className="status-btn ">Status</span>
								</div>
								<div className="task-status yellow">
									<span className="status-btn ">Status</span>
								</div>
								<div className="task-status red">
									<span className="status-btn">Status</span>
								</div>
							</div>
							<div className="one-fourth px-4 py-4">
								<h3 className="semibold-14">With Icon</h3>
								<div className="task-status purple">
									<span className="status-btn">
										Status
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width={18}
											height={18}
											viewBox="0 0 18 18"
											fill="none"
										>
											<path
												d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
												stroke="#452C8E"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M9 4.5V9L12 10.5"
												stroke="#452C8E"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
										</svg>
									</span>
								</div>
								<div className="task-status green">
									<span className="status-btn">
										Status
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width={18}
											height={18}
											viewBox="0 0 18 18"
											fill="none"
										>
											<path
												d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
												stroke="#00C334"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M12.7245 6.29999L7.69488 11.3295L5.3999 9.0345"
												stroke="#00C334"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
										</svg>
									</span>
								</div>
								<div className="task-status yellow">
									<span className="status-btn">
										Status
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width={18}
											height={18}
											viewBox="0 0 18 18"
											fill="none"
										>
											<path
												d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
												stroke="#F57F17"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M9 4.5V9L12 10.5"
												stroke="#F57F17"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
										</svg>
									</span>
								</div>
								<div className="task-status red">
									<span className="status-btn">
										Status
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width={18}
											height={18}
											viewBox="0 0 18 18"
											fill="none"
										>
											<path
												d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
												stroke="#F22B2B"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M9 6V9"
												stroke="#F22B2B"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M9 12H9.00833"
												stroke="#F22B2B"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
										</svg>
									</span>
								</div>
							</div>
							<div className="one-fourth px-4 py-4">
								<h3 className="semibold-14">T time, No icon</h3>
								<div className="task-status purple">
									<span className="status-btn">Status</span>
									<span className="time-count">+2d</span>
								</div>
								<div className="task-status green">
									<span className="status-btn">Status</span>
									<span className="time-count">+2d</span>
								</div>
								<div className="task-status yellow">
									<span className="status-btn">Status</span>
									<span className="time-count">+2d</span>
								</div>
								<div className="task-status red">
									<span className="status-btn">Status</span>
									<span className="time-count">+2d</span>
								</div>
							</div>
							<div className="one-fourth px-4 py-4">
								<h3 className="semibold-14">T time, With icon</h3>
								<div className="task-status purple">
									<span className="status-btn">
										Status
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width={18}
											height={18}
											viewBox="0 0 18 18"
											fill="none"
										>
											<path
												d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
												stroke="#452C8E"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M9 4.5V9L12 10.5"
												stroke="#452C8E"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
										</svg>
									</span>
									<span className="time-count">+2d</span>
								</div>
								<div className="task-status green">
									<span className="status-btn">
										Status
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width={18}
											height={18}
											viewBox="0 0 18 18"
											fill="none"
										>
											<path
												d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
												stroke="#00C334"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M12.7245 6.29999L7.69488 11.3295L5.3999 9.0345"
												stroke="#00C334"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
										</svg>
									</span>
									<span className="time-count">+2d</span>
								</div>
								<div className="task-status yellow">
									<span className="status-btn">
										Status
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width={18}
											height={18}
											viewBox="0 0 18 18"
											fill="none"
										>
											<path
												d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
												stroke="#F57F17"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M9 4.5V9L12 10.5"
												stroke="#F57F17"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
										</svg>
									</span>
									<span className="time-count">+2d</span>
								</div>
								<div className="task-status red">
									<span className="status-btn">
										Status
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width={18}
											height={18}
											viewBox="0 0 18 18"
											fill="none"
										>
											<path
												d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
												stroke="#F22B2B"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M9 6V9"
												stroke="#F22B2B"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M9 12H9.00833"
												stroke="#F22B2B"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
										</svg>
									</span>
									<span className="time-count">+2d</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* Task conversation tag */}
			<section className="px-3 py-4 mt-4 bg-white ">
				<div className="container">
					<h1 className="semibold-18">Task conversation tags</h1>
					<div className="d-flex justify-content-between">
						<span className="task-tag common5">Common 5 task </span>
						<span className="task-tag material">Material</span>
						<span className="task-tag sample">Sample</span>
						<span className="task-tag productionTag">Production</span>
						<span className="task-tag inspection">Inspection</span>
						<span className="task-tag delivery">Delivery</span>
					</div>
				</div>
			</section>
			{/* Color Component  */}
			<section className="px-3 py-4 mt-4 bg-white ">
				<div className="container">
					<div className="row">
						<div className="col-md-12  d-flex bg-white justify-content-between pb-4">
							<div className="colors-list">
								<span style={{ background: '#0c5460' }} />
								<span style={{ background: 'red' }} />
								<span style={{ background: 'green' }} />
								<span style={{ background: '#333' }} />
								<div className="color-amount">4 Colors</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* Progress status  & Stepper*/}
			<section className="steppers only-icon px-3 py-4 mt-4 bg-white ">
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<div className="stepper-component">
								<h1 className="semibold-18">Navigation Stepper</h1>
								{/* Disable Stepper Component  */}
								<h3 className="semibold-14">Disable stepper</h3>
								<div className="stepper-grid d-flex">
									<div className="single-stepper disable d-flex align-items-center">
										<div className="status error cir-progress" data-percentage={100}>
											<span className="cir-progress-left">
												<span className="cir-progress-bar" />
											</span>
											<span className="cir-progress-right">
												<span className="cir-progress-bar" />
											</span>
											<div className="cir-progress-value">
												<div className="task-value">0</div>
											</div>
										</div>
									</div>
									<div className="single-stepper disable d-flex align-items-center">
										<div className="status done cir-progress" data-percentage={100}>
											<span className="cir-progress-left">
												<span className="cir-progress-bar" />
											</span>
											<span className="cir-progress-right">
												<span className="cir-progress-bar" />
											</span>
											<div className="cir-progress-value">
												<div className="task-value">0</div>
											</div>
										</div>
									</div>
									<div className="single-stepper disable d-flex align-items-center">
										<div className="status cir-progress" data-percentage={0}>
											<span className="cir-progress-left">
												<span className="cir-progress-bar" />
											</span>
											<span className="cir-progress-right">
												<span className="cir-progress-bar" />
											</span>
											<div className="cir-progress-value">
												<div className="task-value">0</div>
											</div>
										</div>
									</div>
									<div className="single-stepper disable d-flex align-items-center">
										<div className="status cir-progress" data-percentage={25}>
											<span className="cir-progress-left">
												<span className="cir-progress-bar" />
											</span>
											<span className="cir-progress-right">
												<span className="cir-progress-bar" />
											</span>
											<div className="cir-progress-value">
												<div className="task-value">25</div>
											</div>
										</div>
									</div>
								</div>
								{/* Defult Stepper Component  */}
								<h3 className="semibold-14">Defult stepper</h3>
								<div className="stepper-grid d-flex">
									<div className="single-stepper defult d-flex align-items-center">
										<div className="status error cir-progress" data-percentage={0}>
											<span className="cir-progress-left">
												<span className="cir-progress-bar" />
											</span>
											<span className="cir-progress-right">
												<span className="cir-progress-bar" />
											</span>
											<div className="cir-progress-value">
												<div className="task-value">0</div>
											</div>
										</div>
									</div>
									<div className="single-stepper defult d-flex align-items-center">
										<div className="status done cir-progress" data-percentage={100}>
											<span className="cir-progress-left">
												<span className="cir-progress-bar" />
											</span>
											<span className="cir-progress-right">
												<span className="cir-progress-bar" />
											</span>
											<div className="cir-progress-value">
												<div className="task-value">0</div>
											</div>
										</div>
									</div>
									<div className="single-stepper defult d-flex align-items-center">
										<div className="status pending cir-progress" data-percentage={0}>
											<span className="cir-progress-left">
												<span className="cir-progress-bar" />
											</span>
											<span className="cir-progress-right">
												<span className="cir-progress-bar" />
											</span>
											<div className="cir-progress-value">
												<div className="task-value">0</div>
											</div>
										</div>
									</div>
									<div className="single-stepper defult d-flex align-items-center">
										<div className="status ongoing cir-progress" data-percentage={25}>
											<span className="cir-progress-left">
												<span className="cir-progress-bar" />
											</span>
											<span className="cir-progress-right">
												<span className="cir-progress-bar" />
											</span>
											<div className="cir-progress-value">
												<div className="task-value">25</div>
											</div>
										</div>
									</div>
								</div>
								{/* Active Stepper Component  */}
								<h3 className="semibold-14">Defult stepper</h3>
								<div className="stepper-grid d-flex">
									<div className="single-stepper active d-flex align-items-center">
										<div className="status error cir-progress" data-percentage={0}>
											<span className="cir-progress-left">
												<span className="cir-progress-bar" />
											</span>
											<span className="cir-progress-right">
												<span className="cir-progress-bar" />
											</span>
											<div className="cir-progress-value">
												<div className="task-value">0</div>
											</div>
										</div>
									</div>
									<div className="single-stepper active d-flex align-items-center">
										<div className="status done cir-progress" data-percentage={100}>
											<span className="cir-progress-left">
												<span className="cir-progress-bar" />
											</span>
											<span className="cir-progress-right">
												<span className="cir-progress-bar" />
											</span>
											<div className="cir-progress-value">
												<div className="task-value">0</div>
											</div>
										</div>
									</div>
									<div className="single-stepper active d-flex align-items-center">
										<div className="status pending cir-progress" data-percentage={0}>
											<span className="cir-progress-left">
												<span className="cir-progress-bar" />
											</span>
											<span className="cir-progress-right">
												<span className="cir-progress-bar" />
											</span>
											<div className="cir-progress-value">
												<div className="task-value">0</div>
											</div>
										</div>
									</div>
									<div className="single-stepper active ongoing d-flex align-items-center">
										<div className="status ongoing cir-progress" data-percentage={25}>
											<span className="cir-progress-left">
												<span className="cir-progress-bar" />
											</span>
											<span className="cir-progress-right">
												<span className="cir-progress-bar" />
											</span>
											<div className="cir-progress-value">
												<div className="task-value">25</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							{/* End Stepper Component  */}
						</div>
					</div>
				</div>
			</section>
			{/* File upload component */}
			<section className="file-upload-component">
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							{/* File upload Large*/}
							<h3 className="semibold-18 pt-4 pb-2">File Uploader large</h3>
							<div className="file-uploader large upload-design-image mt-3 mb-4 mb-sm-0 ">
								<label htmlFor="drag-upload" className="drag-upload" />
								<input type="file" id="drag-upload" className="file-upload" name="logo" />
							</div>
						</div>
						<div className="col-md-6">
							{/* File upload small*/}
							<h3 className="semibold-18 pt-4 pb-2">File Uploader small</h3>
							<div className="file-uploader small upload-design-image mt-3 mb-4 mb-sm-0 ">
								<label htmlFor="drag-upload" className="drag-upload" />
								<input type="file" id="drag-upload" className="file-upload" name="logo" />
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* Design card component */}
			<section className="design-card-component my-5">
				<div className="container">
					<div className="row">
						<div className="col-md-6">
							<h3 className="semibold-18 pt-4 pb-2">Without Edit option</h3>
							<div className="single-design-card shadow-1dp">
								<div className="card-top">
									<img src=" /images/design-card-image.png" alt="card-image" />
								</div>
								<div className="card-content">
									<h3 className="semibold-14 design-title">Blue Huddie Long Sleeve</h3>
									<div className="card-info d-flex justify-content-between">
										<p className="regular-14">
											<span className="name">By: </span>Aminul islam
										</p>
										<p className="regular-14">2d ago</p>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<h3 className="semibold-18 pt-4 pb-2">With Edit option</h3>
							<div className="single-design-card with-editable shadow-1dp">
								<div className="card-top">
									<div className="edit-items">
										<div className="select-and-edit d-flex justify-content-between">
											<div className="custom-chekbox">
												<div className="form-group">
													<input
														type="checkbox"
														id="stage1"
														name="Company"
														defaultValue={113}
													/>
													<label htmlFor="stage1" />
												</div>
											</div>
											<div className="option">
												<div className="dropdown">
													<button
														className="btn btn-default dropdown-toggle"
														type="button"
														id="menu1"
														data-toggle="dropdown"
														aria-expanded="false"
													>
														<svg
															width={24}
															height={24}
															viewBox="0 0 24 24"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																d="M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
																fill="#6A7181"
															/>
														</svg>
													</button>
													<ul
														className="dropdown-menu dropdown-menu-right shadow-lg"
														role="menu"
														aria-labelledby="menu1"
														x-placement="bottom-end"
													>
														<li role="presentation" className="px-4 pb-3 pt-3">
															<a
																role="menuitem"
																tabIndex={-1}
																className="font-weight-normal  text-black"
																href="/invoices/edit/10052"
															>
																Edit
															</a>
														</li>
														<li role="presentation" className="px-4 pb-3">
															<a
																role="menuitem"
																tabIndex={-1}
																className="font-weight-normal  text-black"
																href
															>
																Delete
															</a>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
									<img src=" /images/design-card-image.png" alt="card-image" />
								</div>
								<div className="card-content">
									<h3 className="semibold-14 design-title">Blue Huddie Long Sleeve</h3>
									<div className="card-info d-flex justify-content-between">
										<ul className="list-item-with-dot">
											<li>500 MOQ</li>
											<li>Organic</li>
											<li>250 GSM</li>
										</ul>
										<div className="sold-status">
											<svg
												xmlns="http://www.w3.org/2000/svg"
												width={24}
												height={24}
												viewBox="0 0 24 24"
												fill="none"
											>
												<path
													d="M9 22C9.55228 22 10 21.5523 10 21C10 20.4477 9.55228 20 9 20C8.44772 20 8 20.4477 8 21C8 21.5523 8.44772 22 9 22Z"
													stroke="#00C334"
													strokeWidth="1.5"
													strokeLinecap="round"
													strokeLinejoin="round"
												/>
												<path
													d="M20 22C20.5523 22 21 21.5523 21 21C21 20.4477 20.5523 20 20 20C19.4477 20 19 20.4477 19 21C19 21.5523 19.4477 22 20 22Z"
													stroke="#00C334"
													strokeWidth="1.5"
													strokeLinecap="round"
													strokeLinejoin="round"
												/>
												<path
													d="M1 1H5L7.68 14.39C7.77144 14.8504 8.02191 15.264 8.38755 15.5583C8.75318 15.8526 9.2107 16.009 9.68 16H19.4C19.8693 16.009 20.3268 15.8526 20.6925 15.5583C21.0581 15.264 21.3086 14.8504 21.4 14.39L23 6"
													stroke="#00C334"
													strokeWidth="1.5"
													strokeLinecap="round"
													strokeLinejoin="round"
												/>
												<path
													d="M11 7L14 10L20 4"
													stroke="#00C334"
													strokeWidth="1.5"
													strokeLinecap="round"
													strokeLinejoin="round"
												/>
											</svg>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<div className="container">
				<div className="designs-collections-container">
					<div className="collections-row">
						<div className="single-collection-item">
							<div className="product-img-container">
								<div className="prev-img">
									<img alt="" src="/images/design-card-image.png" />
								</div>
								<div className="prev-img-thumb">
									<div className="single-first">
										<img alt="" src="/images/upload-image1.png" />
									</div>
									<div className="single-second">
										<img alt="" src="/images/quote-item5.png" />
									</div>
								</div>
							</div>
							<div className="design-details d-flex justify-content-between">
								<div className="details">
									<p className="regular-14 mt-1 mb-0 gray_dark_02">
										Cotton elastane boat neck (<span>8</span> style)
									</p>
									<p className="status mb-0">
										<span className="name regular-14 gray_dark_02">Aminul islam</span>
										<span className="initial">Initial</span>
									</p>
									<div className="status status-summary">
										<span className="initial">Initial-2</span>
										<span className="development">Dev-4</span>
										<span className="complete">Com-1</span>
										<span className="sold">Sold-1</span>
									</div>
								</div>
							</div>
							<div className="option">
								<div className="dropdown">
									<button
										aria-expanded="false"
										className="btn btn-default dropdown-toggle"
										data-toggle="dropdown"
										id="menu1"
										type="button"
									>
										<img alt="more" src="/icons/more_icon.svg" />
									</button>
									<ul className="dropdown-menu dropdown-menu-right shadow-lg">
										<li className="px-4 pb-3 pt-3">
											<span>Edit</span>
										</li>
										<li className="px-4 pb-3">
											<span>Delete</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Team members component */}
			<div className="team-member-component">
				<div className="container">
					<div className="row">
						<div className="col-md-6">
							<h3 className="semibold-18 pt-4 pb-2">Team members component</h3>
							<section className="team-section full-width">
								<div className="manager-designation-persons bg-white">
									<div className="single-person d-flex justify-content-between align-items-center">
										<div className="person-info d-flex align-items-center">
											<div className="image">
												<img src=" /images/alave.png" alt="person" />
											</div>
											<div className="details-info">
												<div className="name">
													<p>
														Sadat
														<span className="designation">Buying Assitant</span>
													</p>
													<p className="email">sadat.nitex@gmail.com</p>
												</div>
											</div>
										</div>
										<div className="action text-right">
											<a href="#">Remove</a>
										</div>
									</div>
									<div className="single-person d-flex justify-content-between align-items-center">
										<div className="person-info d-flex align-items-center">
											<div className="image">
												<img src=" /images/alave.png" alt="person" />
											</div>
											<div className="details-info">
												<div className="name">
													<p>
														Zahinul Haque
														<span className="designation">
															Business Evangelist
														</span>
													</p>
													<p className="email">zahin1@nitex.io</p>
												</div>
											</div>
										</div>
										<div className="action text-right">
											<a href="#">Remove</a>
										</div>
									</div>
									<div className="single-person d-flex justify-content-between align-items-center">
										<div className="person-info d-flex align-items-center">
											<div className="image">
												<img src=" /images/alave.png" alt="person" />
											</div>
											<div className="details-info">
												<div className="name">
													<p>
														pm
														<span className="designation">Project manager</span>
													</p>
													<p className="email">pm@gmail.com</p>
												</div>
											</div>
										</div>
										<div className="action text-right">
											<a href="#">Remove</a>
										</div>
									</div>
									<div className="single-person d-flex justify-content-between align-items-center">
										<div className="person-info d-flex align-items-center">
											<div className="image">
												<img src=" /images/alave.png" alt="person" />
											</div>
											<div className="details-info">
												<div className="name">
													<p>
														Mamun
														<span className="designation">Quality Assurance</span>
													</p>
													<p className="email">mamun1@nitex.info</p>
												</div>
											</div>
										</div>
										<div className="action text-right">
											<a href="#">Remove</a>
										</div>
									</div>
									<div className="single-person d-flex justify-content-between align-items-center">
										<div className="person-info d-flex align-items-center">
											<div className="image">
												<img src=" /images/alave.png" alt="person" />
											</div>
											<div className="details-info">
												<div className="name">
													<p>
														Sarwar Hossain
														<span className="designation">Merchandiser</span>
													</p>
													<p className="email">sarwar1@nitex.info</p>
												</div>
											</div>
										</div>
										<div className="action text-right">
											<a href="#">Remove</a>
										</div>
									</div>
								</div>
							</section>
						</div>
					</div>
				</div>
			</div>
			{/* Certificate card with edit option */}
			<section className="design-card-component my-5">
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<h3 className="semibold-18 pt-4 pb-2">With Edit option</h3>
							<div className="single-design-card with-editable certificate-card shadow-1dp">
								<div className="card-top">
									<div className="edit-items">
										<div className="select-and-edit d-flex justify-content-between">
											<div className="custom-chekbox">
												<div className="form-group">
													<img src=" /icons/edit-supplier.svg" />
												</div>
											</div>
											<div className="option">
												<div className="dropdown">
													<button
														className="btn btn-default dropdown-toggle"
														type="button"
														id="menu1"
														data-toggle="dropdown"
														aria-expanded="false"
													>
														<img src=" /icons/delete_perple.svg" alt="" />
													</button>
													<ul
														className="dropdown-menu dropdown-menu-right shadow-lg"
														role="menu"
														aria-labelledby="menu1"
														x-placement="bottom-end"
													>
														<li role="presentation" className="px-4 pb-3 pt-3">
															<a
																role="menuitem"
																tabIndex={-1}
																className="font-weight-normal  text-black"
																href="/invoices/edit/10052"
															>
																Edit
															</a>
														</li>
														<li role="presentation" className="px-4 pb-3">
															<a
																role="menuitem"
																tabIndex={-1}
																className="font-weight-normal  text-black"
																href
															>
																Delete
															</a>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
									<img src=" /images/certificate1.png" alt="card-image" />
								</div>
								<div className="card-content">
									<h3 className="regular-14 design-title">Certificates name</h3>
									<p className="regular-12">Expired: 12 Apr, 2021</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* Star status */}
			<section className="design-card-component my-5">
				<div className="container">
					<div className="row">
						<div className="col-md-6">
							<h3 className="semibold-18 pt-4 pb-2">All star status</h3>
							<span className="star-review rating-5">
								<img src=" /icons/star-filled.svg" alt="star" />
								<img src=" /icons/star-filled.svg" alt="star" />
								<img src=" /icons/star-filled.svg" alt="star" />
								<img src=" /icons/star-filled.svg" alt="star" />
								<img src=" /icons/star-filled.svg" alt="star" />
							</span>
							<br />
							<span className="star-review rating-4-half">
								<img src=" /icons/star-filled.svg" alt="star" />
								<img src=" /icons/star-filled.svg" alt="star" />
								<img src=" /icons/star-filled.svg" alt="star" />
								<img src=" /icons/star-filled.svg" alt="star" />
								<img src=" /icons/star-half-filled.png" alt="star" />
							</span>
							<br />
							<span className="star-review rating-4">
								<img src=" /icons/star-filled.svg" alt="star" />
								<img src=" /icons/star-filled.svg" alt="star" />
								<img src=" /icons/star-filled.svg" alt="star" />
								<img src=" /icons/star-filled.svg" alt="star" />
								<img src=" /icons/star-default.svg" alt="star" />
							</span>
							<br />
							<span className="star-review rating-3-half">
								<img src=" /icons/star-filled.svg" alt="star" />
								<img src=" /icons/star-filled.svg" alt="star" />
								<img src=" /icons/star-filled.svg" alt="star" />
								<img src=" /icons/star-half-filled.png" alt="star" />
								<img src=" /icons/star-default.svg" alt="star" />
							</span>
							<br />
							<span className="star-review rating-3">
								<img src=" /icons/star-filled.svg" alt="star" />
								<img src=" /icons/star-filled.svg" alt="star" />
								<img src=" /icons/star-filled.svg" alt="star" />
								<img src=" /icons/star-default.svg" alt="star" />
								<img src=" /icons/star-default.svg" alt="star" />
							</span>
							<br />
							<span className="star-review rating-2-half">
								<img src=" /icons/star-filled.svg" alt="star" />
								<img src=" /icons/star-filled.svg" alt="star" />
								<img src=" /icons/star-half-filled.png" alt="star" />
								<img src=" /icons/star-default.svg" alt="star" />
								<img src=" /icons/star-default.svg" alt="star" />
							</span>
							<br />
							<span className="star-review rating-2">
								<img src=" /icons/star-filled.svg" alt="star" />
								<img src=" /icons/star-filled.svg" alt="star" />
								<img src=" /icons/star-default.svg" alt="star" />
								<img src=" /icons/star-default.svg" alt="star" />
								<img src=" /icons/star-default.svg" alt="star" />
							</span>
							<br />
							<span className="star-review rating-1-half">
								<img src=" /icons/star-filled.svg" alt="star" />
								<img src=" /icons/star-half-filled.png" alt="star" />
								<img src=" /icons/star-default.svg" alt="star" />
								<img src=" /icons/star-default.svg" alt="star" />
								<img src=" /icons/star-default.svg" alt="star" />
							</span>
							<br />
							<span className="star-review rating-1">
								<img src=" /icons/star-filled.svg" alt="star" />
								<img src=" /icons/star-default.svg" alt="star" />
								<img src=" /icons/star-default.svg" alt="star" />
								<img src=" /icons/star-default.svg" alt="star" />
								<img src=" /icons/star-default.svg" alt="star" />
							</span>
							<br />
							<span className="star-review rating-0-half">
								<img src=" /icons/star-half-filled.png" alt="star" />
								<img src=" /icons/star-default.svg" alt="star" />
								<img src=" /icons/star-default.svg" alt="star" />
								<img src=" /icons/star-default.svg" alt="star" />
								<img src=" /icons/star-default.svg" alt="star" />
							</span>
							<br />
							<span className="star-review rating-0">
								<img src=" /icons/star-default.svg" alt="star" />
								<img src=" /icons/star-default.svg" alt="star" />
								<img src=" /icons/star-default.svg" alt="star" />
								<img src=" /icons/star-default.svg" alt="star" />
								<img src=" /icons/star-default.svg" alt="star" />
							</span>
							<br />
						</div>
					</div>
				</div>
			</section>
			{/* Add color component */}
			<section className="color-component my-5">
				<div className="container">
					<div className="row">
						<div className="col-md-6">
							<h3 className="semibold-18 pt-4 pb-2">Add color component</h3>
							<div className="select-component">
								<label htmlFor="collection">Colors</label>
								<div
									className="click-box click mb-1 "
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
								>
									<p className="regular-14 selected-item">Select color</p>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width={24}
										height={24}
										viewBox="0 0 24 24"
										fill="none"
									>
										<path
											d="M15.8805 9.29055L12.0005 13.1705L8.12047 9.29055C7.73047 8.90055 7.10047 8.90055 6.71047 9.29055C6.32047 9.68055 6.32047 10.3105 6.71047 10.7005L11.3005 15.2905C11.6905 15.6805 12.3205 15.6805 12.7105 15.2905L17.3005 10.7005C17.6905 10.3105 17.6905 9.68055 17.3005 9.29055C16.9105 8.91055 16.2705 8.90055 15.8805 9.29055Z"
											fill="#9AA1AF"
										/>
									</svg>
								</div>
								<div
									className="dropdown-box dropdown-menu"
									x-placement="bottom-start"
									style={{
										position: 'absolute',
										willChange: 'transform',
										top: '0px',
										left: '0px',
										transform: 'translate3d(15px, 63px, 0px)'
									}}
								>
									<div className="m-0 search-filter">
										<div className="with-icon right-icon">
											<input type="text" placeholder="Search" defaultValue />
											<span className="right-icon">
												<svg
													width={17}
													height={17}
													viewBox="0 0 17 17"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fillRule="evenodd"
														clipRule="evenodd"
														d="M7.5 0C11.6421 0 15 3.35786 15 7.5C15 9.21015 14.4276 10.7866 13.464 12.0483L16.7071 15.2929C17.0976 15.6834 17.0976 16.3166 16.7071 16.7071C16.3466 17.0676 15.7794 17.0953 15.3871 16.7903L15.2929 16.7071L12.0483 13.464C10.7866 14.4276 9.21015 15 7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0ZM7.5 2C4.46243 2 2 4.46243 2 7.5C2 10.5376 4.46243 13 7.5 13C8.85114 13 10.0885 12.5128 11.0459 11.7045C11.091 11.5536 11.1738 11.412 11.2929 11.2929C11.412 11.1738 11.5536 11.091 11.7041 11.0446C12.5128 10.0885 13 8.85114 13 7.5C13 4.46243 10.5376 2 7.5 2Z"
														fill="#9AA1AF"
													/>
												</svg>
											</span>
										</div>
									</div>
									<div className="add-btn">
										<button className="button text">
											<svg
												width={14}
												height={14}
												viewBox="0 0 14 14"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M13 8H8V13C8 13.55 7.55 14 7 14C6.45 14 6 13.55 6 13V8H1C0.45 8 0 7.55 0 7C0 6.45 0.45 6 1 6H6V1C6 0.45 6.45 0 7 0C7.55 0 8 0.45 8 1V6H13C13.55 6 14 6.45 14 7C14 7.55 13.55 8 13 8Z"
													fill="white"
												/>
											</svg>
											<span className="ml-2">Add color</span>
										</button>
									</div>
									<div className="color-list-box">
										<div className="single-color-item d-flex">
											<div className="one-half color-code">
												<span
													className="color-icon"
													style={{ background: 'rgb(237, 241, 255)' }}
												/>
												<span className="regular-14">11-4001 TCX</span>
											</div>
											<div className="one-half color-name">
												<p className="regular-14">Brilliant White</p>
											</div>
										</div>
										<div className="single-color-item d-flex">
											<div className="one-half color-code">
												<span
													className="color-icon"
													style={{ background: 'rgb(244, 249, 255)' }}
												/>
												<span className="regular-14">11-0601 TCX</span>
											</div>
											<div className="one-half color-name">
												<p className="regular-14">Bright White</p>
											</div>
										</div>
										<div className="single-color-item d-flex">
											<div className="one-half color-code">
												<span
													className="color-icon"
													style={{ background: 'rgb(244, 247, 255)' }}
												/>
												<span className="regular-14">11-0700 TCX</span>
											</div>
											<div className="one-half color-name">
												<p className="regular-14">Lucent White</p>
											</div>
										</div>
										<div className="single-color-item d-flex">
											<div className="one-half color-code">
												<span
													className="color-icon"
													style={{ background: 'rgb(231, 233, 231)' }}
												/>
												<span className="regular-14">11-4800 TCX</span>
											</div>
											<div className="one-half color-name">
												<p className="regular-14">Blanc de Blanc</p>
											</div>
										</div>
										<div className="single-color-item d-flex">
											<div className="one-half color-code">
												<span
													className="color-icon"
													style={{ background: 'rgb(240, 238, 233)' }}
												/>
												<span className="regular-14">11-4201 TCX</span>
											</div>
											<div className="one-half color-name">
												<p className="regular-14">Cloud Dancer</p>
											</div>
										</div>
										<div className="single-color-item d-flex">
											<div className="one-half color-code">
												<span
													className="color-icon"
													style={{ background: 'rgb(241, 238, 230)' }}
												/>
												<span className="regular-14">11-0608 TCX</span>
											</div>
											<div className="one-half color-name">
												<p className="regular-14">Coconut Milk</p>
											</div>
										</div>
										<div className="single-color-item d-flex">
											<div className="one-half color-code">
												<span
													className="color-icon"
													style={{ background: 'rgb(232, 228, 218)' }}
												/>
												<span className="regular-14">11-4801 TCX</span>
											</div>
											<div className="one-half color-name">
												<p className="regular-14">Tofu</p>
											</div>
										</div>
										<div className="single-color-item d-flex">
											<div className="one-half color-code">
												<span
													className="color-icon"
													style={{ background: 'rgb(244, 238, 232)' }}
												/>
												<span className="regular-14">11-0607 TCX</span>
											</div>
											<div className="one-half color-name">
												<p className="regular-14">Sugar Swizzle</p>
											</div>
										</div>
										<div className="single-color-item d-flex">
											<div className="one-half color-code">
												<span
													className="color-icon"
													style={{ background: 'rgb(239, 235, 231)' }}
												/>
												<span className="regular-14">11-1001 TCX</span>
											</div>
											<div className="one-half color-name">
												<p className="regular-14">White Alyssum</p>
											</div>
										</div>
										<div className="single-color-item d-flex">
											<div className="one-half color-code">
												<span
													className="color-icon"
													style={{ background: 'rgb(242, 240, 235)' }}
												/>
												<span className="regular-14">11-0602 TCX</span>
											</div>
											<div className="one-half color-name">
												<p className="regular-14">Snow White</p>
											</div>
										</div>
										<div className="single-color-item d-flex">
											<div className="one-half color-code">
												<span
													className="color-icon"
													style={{ background: 'rgb(239, 239, 232)' }}
												/>
												<span className="regular-14">11-4202 TCX</span>
											</div>
											<div className="one-half color-name">
												<p className="regular-14">Star White</p>
											</div>
										</div>
										<div className="single-color-item d-flex">
											<div className="one-half color-code">
												<span
													className="color-icon"
													style={{ background: 'rgb(240, 238, 228)' }}
												/>
												<span className="regular-14">11-4300 TCX</span>
											</div>
											<div className="one-half color-name">
												<p className="regular-14">Marshmallow</p>
											</div>
										</div>
										<div className="single-color-item d-flex">
											<div className="one-half color-code">
												<span
													className="color-icon"
													style={{ background: 'rgb(241, 240, 226)' }}
												/>
												<span className="regular-14">11-4302 TCX</span>
											</div>
											<div className="one-half color-name">
												<p className="regular-14">Cannoli Cream</p>
											</div>
										</div>
										<div className="single-color-item d-flex">
											<div className="one-half color-code">
												<span
													className="color-icon"
													style={{ background: 'rgb(243, 236, 224)' }}
												/>
												<span className="regular-14">11-0103 TCX</span>
											</div>
											<div className="one-half color-name">
												<p className="regular-14">Egret</p>
											</div>
										</div>
										<div className="single-color-item d-flex">
											<div className="one-half color-code">
												<span
													className="color-icon"
													style={{ background: 'rgb(240, 234, 218)' }}
												/>
												<span className="regular-14">11-0104 TCX</span>
											</div>
											<div className="one-half color-name">
												<p className="regular-14">Vanilla Ice</p>
											</div>
										</div>
										<div className="single-color-item d-flex">
											<div className="one-half color-code">
												<span
													className="color-icon"
													style={{ background: 'rgb(242, 232, 218)' }}
												/>
												<span className="regular-14">11-0606 TCX</span>
											</div>
											<div className="one-half color-name">
												<p className="regular-14">Pristine</p>
											</div>
										</div>
										<div className="single-color-item d-flex">
											<div className="one-half color-code">
												<span
													className="color-icon"
													style={{ background: 'rgb(237, 230, 219)' }}
												/>
												<span className="regular-14">11-0701 TCX</span>
											</div>
											<div className="one-half color-name">
												<p className="regular-14">Whisper White</p>
											</div>
										</div>
										<div className="single-color-item d-flex">
											<div className="one-half color-code">
												<span
													className="color-icon"
													style={{ background: 'rgb(236, 225, 211)' }}
												/>
												<span className="regular-14">12-0601 TCX</span>
											</div>
											<div className="one-half color-name">
												<p className="regular-14">Eggnog</p>
											</div>
										</div>
										<div className="single-color-item d-flex">
											<div className="one-half color-code">
												<span
													className="color-icon"
													style={{ background: 'rgb(241, 233, 223)' }}
												/>
												<span className="regular-14">11-0604 TCX</span>
											</div>
											<div className="one-half color-name">
												<p className="regular-14">Gardenia</p>
											</div>
										</div>
										<div className="single-color-item d-flex">
											<div className="one-half color-code">
												<span
													className="color-icon"
													style={{ background: 'rgb(237, 230, 222)' }}
												/>
												<span className="regular-14">11-0605 TCX</span>
											</div>
											<div className="one-half color-name">
												<p className="regular-14">Jet Stream</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* Pending order stepper */}
			<section className=" my-5">
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<h3 className="semibold-18 pt-4 pb-2">Pending order stepper</h3>
							<div className="pending-order-stepper">
								<ul className="d-flex">
									<li>
										<span className="step-count done">
											<img src=" /icons/tick-green.png" alt="tich" />
										</span>{' '}
										Order info
									</li>
									<li>
										<span className="step-count current">
											<span className="custom-tooltip">
												<img src=" /images/jobaidu.png" alt="profile" />
												<span className="tooltiptext">Hover over me</span>
											</span>
										</span>
										Proforma invoice
									</li>
									<li>
										<span className="step-count">3</span> Supplier
									</li>
									<li>
										<span className="step-count">4</span> Sales contact
									</li>
									<li>
										<span className="step-count">5</span> Material list
									</li>
									<li>
										<span className="step-count">6</span> Team
									</li>
									<li>
										<span className="step-count">7</span> TNA
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* Common box layout design */}
			<section className="common-box-component">
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<h3 className="semibold-18 pt-4 pb-2">Common Box</h3>
							<div className="common-box">
								<div className="common-box-header">
									<div className="left-half">
										<h3 className="semibold-16 mb-0">Bank information</h3>
									</div>
									<div className="right-half text-right">
										<button className="button text size32">
											<span className>Add</span>
											<img src=" /icons/add-round.svg" alt="add" />
										</button>
									</div>
								</div>
								<div className="common-box-body">
									<div className="full-content">
										<div className="single-content-box">
											<div className="content-heading location-heading mb-2">
												<span className="semibold-14 mb-0">Bank Details title 1</span>
												<img src=" /icons/edit-supplier.svg" alt="edit" />
											</div>
											<div className="info-details">
												<p className="regular-14 gray_dark_01">
													<span>Swift:</span> OCBCSGSGXXX
												</p>
												<p className="regular-14 gray_dark_01">
													<span>A/C:</span> 501235535301
												</p>
												<p className="regular-14 gray_dark_01">
													Oversea-Chinese Banking Corporation Limited{' '}
												</p>
												<p className="regular-14 gray_dark_01">
													65 Chilua Street,OCBC Centre,Singapore 049513, Singapore.
												</p>
											</div>
										</div>
									</div>
									<div className="full-content">
										<div className="single-content-box">
											<div className="content-heading location-heading mb-2">
												<span className="semibold-14 mb-0">Bank Details title2</span>
												<img src=" /icons/edit-supplier.svg" alt="edit" />
											</div>
											<div className="info-details">
												<p className="regular-14 gray_dark_01">
													<span>Swift:</span> OCBCSGSGXXX
												</p>
												<p className="regular-14 gray_dark_01">
													<span>A/C:</span> 501235535301
												</p>
												<p className="regular-14 gray_dark_01">
													Oversea-Chinese Banking Corporation Limited{' '}
												</p>
												<p className="regular-14 gray_dark_01">
													65 Chilua Street,OCBC Centre,Singapore 049513, Singapore.
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section className="common-select-component pb-5">
				<div className="container">
					<div className="row">
						<div className="col-md-6">
							<h3 className="semibold-18 pt-4 pb-2">Common select component </h3>
							<div className="select-component">
								<div
									className="click-box click mb-1"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
								>
									<p className="regular-14 ">Select brand</p>
									<img src=" /images/chevron_down.svg" alt="" />
								</div>
								<div className="dropdown-box dropdown-menu">
									<div className="m-0 search-filter">
										<div className="with-icon right-icon">
											<input type="text" placeholder="Search" defaultValue />
											<span className="right-icon">
												<img src=" /icons/search.png" alt="" />
											</span>
										</div>
									</div>
									<div className="add-btn">
										<button className="button text">
											<img src=" /icons/add_primary.svg" alt="" />
											<span className="ml-1">Add Item</span>
										</button>
									</div>
									<div className="list-items scroll-y-label">
										<div className="single-item">
											<p>Item 1</p>
										</div>
										<div className="single-item">
											<p>Item 2</p>
										</div>
										<div className="single-item">
											<p>Item 3</p>
										</div>
										<div className="single-item">
											<p>Item 4</p>
										</div>
										<div className="single-item">
											<p>Item 5</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<h3 className="semibold-18 pt-4 pb-2">Common search select component </h3>
							<div className="select-component">
								<div
									className="click-box click mb-1"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
								>
									<input
										type="text"
										placeholder="Search or add status"
										defaultValue
										className="w-100"
									/>
								</div>
								<div className="dropdown-box dropdown-menu">
									<div className="add-btn">
										<button className="button text">
											<span className="regular-14 gray_dark_01">
												<span className="weight-500">ADD:</span>
												Item
											</span>
										</button>
									</div>
									<div className="list-items scroll-y-label">
										<div className="single-item">
											<p>Item 1</p>
										</div>
										<div className="single-item">
											<p>Item 2</p>
										</div>
										<div className="single-item">
											<p>Item 3</p>
										</div>
										<div className="single-item">
											<p>Item 4</p>
										</div>
										<div className="single-item">
											<p>Item 5</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* Common list component */}
			<section className="common-select-component pb-5">
				<div className="container">
					<div className="row">
						<div className="col-md-6">
							<h3 className="semibold-18 pt-4 pb-2">Common list component </h3>
							<ul className="common-list-component">
								<li>Men</li>
								<li>Design category</li>
								<li>25 APR, 22</li>
							</ul>
						</div>
					</div>
				</div>
			</section>
			{/* Design timeline */}
			<section className="common-select-component pb-5">
				<div className="container">
					<div className="row">
						<div className="col-md-6">
							<div className="design-timeline-container">
								<div className="design-timeline-header mb-3">
									<p className="regular-14 gray_dark_01">Design timeline</p>
									<p className="regular-12 gray_dark_02">Reqired: 2 APR, 22</p>
								</div>
								<ul className="design-timeline design-timeline-centered">
									<li className="design-timeline-item">
										<div className="design-timeline-info">
											<span className="regular-12 gray_dark_01">23 MAR</span>
										</div>
										<div className="design-timeline-marker" />
										<div className="design-timeline-content">
											<p className="regular-12 green">Design uploaded</p>
										</div>
									</li>
									<li className="design-timeline-item">
										<div className="design-timeline-info">
											<span className="regular-12 gray_dark_01">23 MAR</span>
										</div>
										<div className="design-timeline-marker" />
										<div className="design-timeline-content">
											<p className="regular-12 green">Sample requested</p>
										</div>
									</li>
									<li className="design-timeline-item">
										<div className="design-timeline-info">
											<span className="regular-12 gray_dark_01">26 MAR</span>
										</div>
										<div className="design-timeline-marker" />
										<div className="design-timeline-content">
											<p className="regular-12 green">Pattern</p>
										</div>
									</li>
									<li className="design-timeline-item">
										<div className="design-timeline-info">
											<span className="regular-12 blue">26 MAR</span>
										</div>
										<div className="design-timeline-marker" />
										<div className="design-timeline-content">
											<p className="regular-12 blue">Sewing</p>
										</div>
									</li>
									<li className="design-timeline-item">
										<div className="design-timeline-info">
											<span className="regular-12 blue" />
										</div>
										<div className="design-timeline-marker" />
										<div className="design-timeline-content">
											<p className="regular-12 gray_dark_03">Print</p>
										</div>
									</li>
									<li className="design-timeline-item">
										<div className="design-timeline-info">
											<span className="regular-12 blue" />
										</div>
										<div className="design-timeline-marker" />
										<div className="design-timeline-content">
											<p className="regular-12 gray_dark_03">Wash</p>
										</div>
									</li>
									<li className="design-timeline-item">
										<div className="design-timeline-info">
											<span className="regular-12 blue" />
										</div>
										<div className="design-timeline-marker" />
										<div className="design-timeline-content">
											<p className="regular-12 gray_dark_03">Emboidery</p>
										</div>
									</li>
									<li className="design-timeline-item">
										<div className="design-timeline-info">
											<span className="regular-12 blue" />
										</div>
										<div className="design-timeline-marker" />
										<div className="design-timeline-content">
											<p className="regular-12 gray_dark_03">Delivered</p>
										</div>
									</li>
									<li className="design-timeline-item">
										<div className="design-timeline-info">
											<span className="regular-12 blue" />
										</div>
										<div className="design-timeline-marker" />
										<div className="design-timeline-content">
											<p className="regular-12 gray_dark_03">Costing</p>
										</div>
									</li>
									<li className="design-timeline-item">
										<div className="design-timeline-info">
											<span className="regular-12 blue" />
										</div>
										<div className="design-timeline-marker" />
										<div className="design-timeline-content">
											<p className="regular-12 gray_dark_03">Photoshoot</p>
										</div>
									</li>
									<li className="design-timeline-item">
										<div className="design-timeline-info">
											<span className="regular-12 blue" />
										</div>
										<div className="design-timeline-marker" />
										<div className="design-timeline-content">
											<p className="regular-12 gray_dark_03">Published</p>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* Progress bottom */}
			<div className="progress-fixed-bottom">
				<div className="header d-flex align-items-center justify-content-between">
					<p className="regular-12">
						{' '}
						<span>Copying to</span> Collection name here and(30C)...{' '}
						<img src=" /icons/external-link.svg" alt="link" />
					</p>
					<div className="close">
						<span>
							<img src=" /icons/close.svg" alt="close" />
						</span>
					</div>
				</div>
				<div className="details d-flex justify-content-between align-items-center">
					<div className="progress-info">
						<div className="progress">
							<div
								className="progress-bar completed"
								role="progressbar"
								style={{ width: '80%' }}
								aria-valuenow={15}
								aria-valuemin={0}
								aria-valuemax={100}
							/>
						</div>
					</div>
					<div className="value">
						<p className="semibold-12">
							{' '}
							12<span className="gray_dark_02">/20</span>
						</p>
					</div>
				</div>
			</div>
		</div>
	);
}
export default UiComponent;
